import { useQuery, useMutation } from "@tanstack/react-query";
import {
  getSubscription,
  createCheckoutSession,
  createPortalSession,
} from "@/services/billing";

const BILLING_KEY = ["admin", "billing", "subscription"];

export function useSubscription() {
  return useQuery({
    queryKey: BILLING_KEY,
    queryFn: getSubscription,
  });
}

export function useCreateCheckoutSession() {
  return useMutation({
    mutationFn: (priceId: string) => createCheckoutSession(priceId),
  });
}

export function useCreatePortalSession() {
  return useMutation({
    mutationFn: () => createPortalSession(),
  });
}
